import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PortalCustomer {
  id: string;
  name: string;
  phone: string;
  email?: string;
}

interface PortalState {
  token: string | null;
  customer: PortalCustomer | null;
  isAuthenticated: boolean;
  setAuth: (token: string, customer: PortalCustomer) => void;
  logout: () => void;
}

export const usePortalStore = create<PortalState>()(
  persist(
    (set) => ({
      token: null,
      customer: null,
      isAuthenticated: false,
      setAuth: (token, customer) => set({ token, customer, isAuthenticated: true }),
      logout: () => set({ token: null, customer: null, isAuthenticated: false }),
    }),
    { name: 'clearring-portal-auth' },
  ),
);
